/** X's weighted length, as the server's publisher.XWeightedLength counts it:
 *  a link is 23 whatever its length, Latin and common punctuation count 1,
 *  and Hangul, kana, CJK and emoji count 2 — a Korean post fits about 140
 *  characters, not 280. */
export const X_MAX = 280
const URL_WEIGHT = 23

// What X turns into a t.co link: a URL with a scheme, or a bare domain on a
// common TLD. Same pattern as the server's.
const LINK = /https?:\/\/\S+|\b(?:[a-z0-9-]+\.)+(?:com|net|org|app|io|co|kr|dev|ai|me|ly|click|so|xyz)\b(?:\/\S*)?/gi

export function xLength(text: string): number {
  let n = 0
  const rest = text.replace(LINK, () => {
    n += URL_WEIGHT
    return ''
  })
  for (const ch of rest) {
    const c = ch.codePointAt(0) ?? 0
    const light =
      c <= 0x10ff || (c >= 0x2000 && c <= 0x200d) || (c >= 0x2010 && c <= 0x201f) || (c >= 0x2032 && c <= 0x2037)
    n += light ? 1 : 2
  }
  return n
}

/** A post with a link bills as one: $0.20 against $0.015 (2026-10). */
export const xHasLink = (text: string) => new RegExp(LINK.source, 'i').test(text)
